import { colors } from 'constants/colors';
import React from 'react';
import styled from '@emotion/styled';
const TextLink = ({ color = 'white', size = 'small', onClick, children, className }) => {
    return (React.createElement(Container, { color: color, size: size, className: className, onClick: onClick }, children));
};
const styleBySize = {
    smallShort: `
    border-radius: 108px;
  `,
    small: `
    padding: 8px 16px;
    border: solid 2px ${colors.sailBlue};
    border-radius: 108px;
  `,
    medium: `
    padding: 12px 16px;
    border: solid 2px ${colors.sailBlue}
    border-radius: 108px;
  `,
    mediumLong: `
    padding: 12px 24px;
    border-radius: 108px;
    line-height: 114%
  `,
    large: `
    width: 460px;
    height: 120px;
    border: solid 4px ${colors.sailBlue};
    border-radius: 188px;
    
  `,
};
const styleByColor = {
    white: `
    background-color: ${colors.white};
    color: ${colors.sailBlue};  
  `,
    blue: `
    background-color: ${colors.sailBlue};
    color: ${colors.white};
  `,
    gray: `
    background-color: ${colors.mediumGray};
    color: ${colors.white};
  `,
};
const Container = styled.button `
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  font-weight: bold;
  font-size: 28px;
  letter-spacing: 0.3px;
  cursor: pointer;
  ${(props) => styleByColor[props.color]};
  ${(props) => styleBySize[props.size]};
`;
export default TextLink;
